import { Grid } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import EvolutionCard from '../../../../Components/EvolutionCard'
import LineBarGraph from './LineBarGraph'
import { makeGetRequest } from '../../../../utils/api'
import urls from '../../../../utils/urls'
import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { setAppStore } from 'reduxLib/slices/mainAppSlice'
import { useDispatch } from 'react-redux'
import CloseIcon from '@mui/icons-material/Close'

function MonCashFlow() {
  const dispatch = useDispatch()
  const getAppStore = useSelector((store) => store.appStore).appStore
  const params = useParams()
  const [data, setData] = useState({})
  useEffect(() => {
    fetchMonCashFlowdetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const fetchMonCashFlowdetails = async (year) => {
    let queryParams = ''
    if (year) {
      queryParams += `year=${year}&`
    }
    const url = `${urls.fetchDashboardDetailsEvolutions(params.slug)}/?${queryParams}`
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setData({ ...response.data })
    }
  }
  return (
    <>
      <Grid container spacing={1} marginTop={2}>
        <Grid item md={12} sm={12}>
          <Box className={getAppStore.expandChart ? 'expand_chart' : ''}>
            {getAppStore.expandChart && (
              <CloseIcon
                onClick={() => dispatch(setAppStore({ expandChart: false }))}
                sx={{
                  color: 'white',
                  cursor: 'pointer',
                  position: 'absolute',
                  right: '60px',
                  top: '40px',
                }}
              />
            )}
            <LineBarGraph data={data} filters={fetchMonCashFlowdetails} />
          </Box>
        </Grid>
        {/* <Grid item md={2} sm={12}>
          <Box
            display={'flex'}
            flexDirection="column"
            justifyContent={'space-between'}
            height="100%"
          >
            <EvolutionCard data={data.moyen} text={'Cashflow Moyen'} width="100%" />
            <EvolutionCard data={data.N1} text={'Evolution N-1'} width="100%" />
            <EvolutionCard data={data.M1} text={'Evolution M-1'} width="100%" />
          </Box>
        </Grid> */}
      </Grid>
    </>
  )
}

export default MonCashFlow
